import { render, staticRenderFns } from "./EditAccesoDatos.vue?vue&type=template&id=267d56b6&scoped=true"
import script from "./EditAccesoDatos.vue?vue&type=script&lang=js"
export * from "./EditAccesoDatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267d56b6",
  null
  
)

export default component.exports